import { render, staticRenderFns } from "./NewReservationPage.vue?vue&type=template&id=449f39cc&scoped=true&"
import script from "./NewReservationPage.vue?vue&type=script&lang=js&"
export * from "./NewReservationPage.vue?vue&type=script&lang=js&"
import style0 from "./NewReservationPage.vue?vue&type=style&index=0&id=449f39cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449f39cc",
  null
  
)

export default component.exports